import { render, staticRenderFns } from "./RecruitmentEditor.vue?vue&type=template&id=6c034176&scoped=true&"
import script from "./RecruitmentEditor.vue?vue&type=script&lang=js&"
export * from "./RecruitmentEditor.vue?vue&type=script&lang=js&"
import style0 from "./RecruitmentEditor.vue?vue&type=style&index=0&id=6c034176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c034176",
  null
  
)

export default component.exports